import { useState, useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Methodology } from './components/Methodology';
import { PricingPlans } from './components/PricingPlans';
import { ClientStoriesSection } from './components/ClientStoriesSection';
import { CampaignBanner } from './components/CampaignBanner';
import { ConsultationForm } from './components/ConsultationForm';
import { ResultsAndFaq } from './components/ResultsAndFaq';
import { Footer } from './components/Footer';
import { PrivateOfferModal } from './components/PrivateOfferModal';

export function App() {
  const [selectedPlanForModal, setSelectedPlanForModal] = useState<string | null>(null);
  const [marketContextForModal, setMarketContextForModal] = useState<{ marketCode?: string; versionId?: string }>({});
  const [isConsultationModalOpen, setIsConsultationModalOpen] = useState(false);
  const [offerToken, setOfferToken] = useState<string | null>(null);

  // Parse /offer/:token or ?offerToken= query from URL
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const path = window.location.pathname;
      const match = path.match(/\/offer\/([a-zA-Z0-9_-]+)/);
      if (match && match[1]) {
        setOfferToken(match[1]);
      } else {
        const params = new URLSearchParams(window.location.search);
        const qToken = params.get('offerToken') || params.get('offer');
        if (qToken) {
          setOfferToken(qToken);
        }
      }
    }
  }, []);

  const handleSelectPlan = (planId: string, marketContext?: { marketCode: string; versionId?: string }) => {
    setSelectedPlanForModal(planId);
    if (marketContext) {
      setMarketContextForModal(marketContext);
    }
    setIsConsultationModalOpen(true);
  };

  const handleOpenGeneralConsultation = () => {
    setSelectedPlanForModal('personalized-coaching');
    setIsConsultationModalOpen(true);
  };

  return (
    <div className="everforge-app" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Dynamic Seasonal / Festival Promotional Banner */}
      <CampaignBanner onOpenConsultation={handleOpenGeneralConsultation} />

      {/* Global Navigation */}
      <Navbar onOpenConsultation={handleOpenGeneralConsultation} />

      <main style={{ flex: 1 }}>
        {/* Hero Section with key value props and trust anchors */}
        <Hero onOpenConsultation={handleOpenGeneralConsultation} />

        {/* Methodology & Coaching Pillars */}
        <Methodology />

        {/* Dynamic Client Stories / Social Proof */}
        <ClientStoriesSection />

        {/* Interactive Pricing and Plan Comparison with 1, 3, 6, 12 month commitments */}
        <PricingPlans onSelectPlan={handleSelectPlan} />

        {/* Essential Frequently Asked Questions */}
        <ResultsAndFaq />

        {/* Inline Application & Consultation Preview Form */}
        <ConsultationForm initialPlanId={selectedPlanForModal || 'personalized-coaching'} />
      </main>

      {/* Footer with links, domain boundaries, and disclaimers */}
      <Footer />

      {/* Modal Consultation Form when triggered from plan cards / CTA */}
      {isConsultationModalOpen && (
        <ConsultationForm
          isModal={true}
          initialPlanId={selectedPlanForModal || 'personalized-coaching'}
          initialMarketCode={marketContextForModal.marketCode}
          initialPricingVersionId={marketContextForModal.versionId}
          onClose={() => setIsConsultationModalOpen(false)}
        />
      )}

      {/* Private Offer Proposal Modal when prospect opens token link */}
      {offerToken && (
        <PrivateOfferModal
          token={offerToken}
          onClose={() => setOfferToken(null)}
        />
      )}
    </div>
  );
}

export default App;
